import React from 'react';
import {
  IChangeSitePasswordPageProps,
  IChangeSitePasswordPageRouteParams,
} from './types';
import { useParams, useHistory } from 'react-router-dom';
import { useDataFetcher } from '../../../hooks';
import { Container } from 'react-bootstrap';
import { Form, FormHeading, Well } from '../../../form';
import AjaxErrorBoundary from '../../../ajax/errorBoundary';
import ChangeSitePasswordForm from './ChangeSitePasswordForm';
import changePassword from './changeSitePassword';
import schema from './schema';

const ChangeSitePasswordPage: React.FC<IChangeSitePasswordPageProps> = ({
  siteAdminPassword,
}) => {
  const history = useHistory();
  const { pin } = useParams<IChangeSitePasswordPageRouteParams>();

  const sitePin = siteAdminPassword ? '0000' : pin;
  const returnUrl = siteAdminPassword ? '/admin' : '/admin/sites';

  const { busy, errors, data: site } = useDataFetcher(`api/sites/${sitePin}`);

  return (
    <Container fluid>
      <Well>
        <FormHeading title="Change Password" backPath={returnUrl} />
        <AjaxErrorBoundary
          busy={busy}
          loadingText={'Loading data'}
          errors={errors}
        >
          {siteAdminPassword ? (
            <p>Please enter the new administrator password</p>
          ) : (
            <p>
              Please enter the new password for site {pin} - {site?.name}
            </p>
          )}

          <Form
            initialValues={{
              pin: sitePin,
              password: '',
              confirmPassword: '',
            }}
            promise={changePassword}
            validationSchema={schema}
            onSubmit={() => history.push(returnUrl)}
          >
            <ChangeSitePasswordForm />
          </Form>
        </AjaxErrorBoundary>
      </Well>
    </Container>
  );
};

export default ChangeSitePasswordPage;
